module.exports = __webpack_public_path__ + "static/img/authority.59ff14b3.jpg";